
export const WheelScreen = () => `
    <div id="wheel-screen" class="screen">
        <h2 class="screen-title">ŞANS ÇARKI</h2>
        
        <div class="wheel-content-wrapper">
            <!-- LEFT: Wheel -->
            <div class="wheel-section-left">
                <div class="wheel-container">
                    <div class="wheel-pointer">▼</div>
                    <canvas id="wheel-canvas" width="440" height="440"></canvas>
                    <div class="wheel-center">
                        <button id="spin-btn">ÇEVİR</button>
                    </div>
                </div>
            </div>

            <!-- RIGHT: Stats & Results -->
            <div class="wheel-section-right">
                <div class="wheel-stats">
                    Kalan Hakkın: <span id="spin-count" class="accent-gold">10</span>
                </div>
                
                <div id="spin-result-text">Kategorini Seç!</div>

                <div id="wheel-results-container">
                    <h3>Toplanan Kategoriler</h3>
                    <div id="collected-questions-list">
                        <!-- Items will be added here -->
                    </div>
                </div>

                <!-- Action Buttons -->
                <div style="margin-top: 1rem; display: flex; gap: 10px; flex-direction: column; width: 100%; align-items: center;">
                    <button id="auto-spin-btn" class="gaddar-btn secondary" style="font-size: 0.9rem; padding: 0.5rem 1rem;">
                        ⚡ OTOMATİK ÇEVİR
                    </button>
                    
                    <div id="wheel-actions" class="hidden">
                        <button id="start-wheel-game-btn" class="gaddar-btn primary">
                            OYUNA BAŞLA
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
`;
